export default "__VITE_ASSET__Ddo6Uu6a__"